import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import { getTakenAssessments } from 'containers/Assessments/actions';
import { makeSelectTakenAssessments } from 'containers/Assessments/selectors';
import { makeSelectClientLanding } from 'containers/ClientLanding/selectors';
import {
  makeSelectLocales,
  makeSelectLanguage,
} from 'containers/Main/selectors';
import CloseIcon from '../images/close.svg';

import Logo from '../images/big-logo.svg';

import MobileAccountInfo from './MobileAccountInfo';
import ClientLogo from './ClientLogo';

import NavBarContext from '../navBarContext';

const styles = theme => ({
  close: {
    position: 'absolute',
    top: 20,
    left: 15,
    zIndex: 10,
    cursor: 'pointer',
  },
  closeIcon: {
    fontSize: 35,
  },
  contentContainer: {
    padding: '0 15px',
    height: 'calc(100% - 40%)',
  },
  subList: {
    margin: '0 5%',
    '& hr': {
      marginBottom: 8,
    },
  },
  link: {
    margin: '5px 5%',
    cursor: 'pointer',
  },
  logo: {
    maxHeight: 45,
    height: 45,
    [theme.breakpoints.down('xs')]: {
      maxHeight: 30,
      height: 30,
    },
  },
  listIcon: {
    minWidth: 40,
    '& img': {
      height: 18,
      width: 18,
    },
  },
  listItemText: {
    '& span': theme.typography.body2,
  },
  listItemTextActive: {
    '& span': {
      color: theme.palette.primary.main,
    },
  },
  listItem: {
    paddingTop: 10,
    paddingBottom: 10,
  },

  header: {
    height: 75,
    borderBottom: '1px solid #E3E3E3',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

class DialogMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showResources: false,
    };
  }

  componentDidMount() {
    const { auth } = this.props;

    if (auth.isLoaded && !auth.isEmpty) {
      this.props.getTakenAssessments();
    }
  }

  componentDidUpdate(prevProps) {
    const { auth } = this.props;
    if (!prevProps.auth.isLoaded && auth.isLoaded && !auth.isEmpty) {
      this.props.getTakenAssessments();
    }
  }

  toggleResources = () => {
    this.setState(prevState => ({
      showResources: !prevState.showResources,
    }));
  };

  // toggleTopics = () => {
  //   this.setState(
  //     prevState => ({
  //       showAssessments: false,
  //       showTopics: !prevState.showTopics,
  //     }),
  //     async () => {
  //       if (this.state.showTopics) {
  //         const {
  //           clientLanding,
  //           clientDetails,
  //           locales,
  //           location,
  //         } = this.props;
  //         this.setState({
  //           fetchingTopics: true,
  //         });

  //         const clientTopTopics = _get(
  //           clientLanding,
  //           'topTopicsCollection.items',
  //         );

  //         if (!_isEmpty(clientDetails) && !_isEmpty(clientTopTopics)) {
  //           this.setState({
  //             topics: clientTopTopics,
  //             fetchingTopics: false,
  //           });
  //         } else {
  //           const clientExcludedTopic = _get(
  //             clientDetails,
  //             'excludeTopicCollection.items',
  //           );
  //           const excludedTopicId =
  //             !_isEmpty(clientExcludedTopic) &&
  //             clientExcludedTopic.map(({ sys }) => sys.id).join(',');
  //           const locale = location;
  //           const { data } = await GqlClient.query({
  //             query: GET_TOPICS,
  //             variables: {
  //               excludedTopicId: excludedTopicId || '',
  //               limit: 7,
  //               locale,
  //             },
  //           });

  //           this.setState({
  //             topics: data.topicsCollection.items,
  //             fetchingTopics: false,
  //           });
  //         }
  //       }
  //     },
  //   );
  // };

  // toggleAssessments = () => {
  //   this.setState(
  //     prevState => ({
  //       showTopics: false,
  //       showAssessments: !prevState.showAssessments,
  //       fetchingAssessments: true,
  //     }),
  //     async () => {
  //       if (this.state.showAssessments) {
  //         const { location } = this.props;
  //         const locale = location;
  //         const { data } = await GqlClient.query({
  //           query: GET_ASSESSMENTS,
  //           variables: {
  //             locale,
  //           },
  //         });

  //         this.setState({
  //           assessments: data.assessmentsCollection.items,
  //           fetchingAssessments: false,
  //         });
  //       }
  //     },
  //   );
  // };

  render() {
    const {
      allowSignIn,
      classes,
      open,
      handleClose,
      isAuthenticated,
      redirect,
      profile,
      logout,
      clientDetails,
      hasClientLogo,
    } = this.props;
    const { siteCopy } = this.context;
    return (
      <Dialog fullScreen open={open} onClose={handleClose}>
        <div className={classes.header}>
          <IconButton
            color="inherit"
            onClick={handleClose}
            aria-label="Close"
            className={classes.close}
          >
            <img src={CloseIcon} alt="Close" className={classes.closeIcon} />
          </IconButton>
          <div>
            {hasClientLogo ? (
              <ClientLogo clientDetails={clientDetails} isDialog />
            ) : (
              <img src={Logo} alt="Logo" className={classes.logo} />
            )}
          </div>
        </div>
        {allowSignIn && (
          <div>
            <MobileAccountInfo
              isAuthenticated={isAuthenticated}
              logout={logout}
              profile={profile}
              redirect={redirect}
              hasClientLogo={hasClientLogo}
              siteCopy={siteCopy}
            />
          </div>
        )}
        {/* <List className={classes.contentContainer}>
          {allowSignIn && <Divider />}
          <ListItem
            button
            onClick={this.toggleTopics}
            className={classes.listItem}
          >
            <ListItemIcon className={classes.listIcon}>
              <img
                src={showTopics ? TopicsIconActive : TopicsIcon}
                alt="Topics"
              />
            </ListItemIcon>
            <ListItemText
              primary={_get(siteCopy, ['pageCopy', 'submenu-labels', 'topics'])}
              className={ClassNames(
                classes.listItemText,
                showTopics ? classes.listItemTextActive : undefined,
              )}
            />
            <img src={showTopics ? ArrowUp : ArrowDown} alt="Arrow" />
          </ListItem>
          {showTopics && (
            <List className={classes.subList}>
              <Divider />
              {fetchingTopics ? (
                <LoadingIndicator />
              ) : (
                !_isEmpty(topics) &&
                topics.map(({ title, slug }) => (
                  <LinkList
                    name={title}
                    link={`/topics/${slug}`}
                    clickHandler={redirect}
                    key={title}
                  />
                ))
              )}
              <Typography
                className={classes.link}
                onClick={() => redirect('/topics')}
              >
                {_get(siteCopy, ['pageCopy', 'mobile-dialog-menu', 'view-all'])}
              </Typography>
            </List>
          )}
          <Divider />
          <ListItem
            button
            onClick={this.toggleAssessments}
            className={classes.listItem}
          >
            <ListItemIcon className={classes.listIcon}>
              <img
                src={showAssessments ? AssessmentsIconActive : AssessmentsIcon}
                alt="Assessments"
              />
            </ListItemIcon>
            <ListItemText
              primary={_get(siteCopy, [
                'pageCopy',
                'submenu-labels',
                'assessments',
              ])}
              className={ClassNames(
                classes.listItemText,
                showAssessments ? classes.listItemTextActive : undefined,
              )}
            />
            <img src={showAssessments ? ArrowUp : ArrowDown} alt="Arrow" />
          </ListItem>
          {showAssessments && (
            <List className={classes.subList}>
              <Divider />
              {fetchingAssessments ? (
                <LoadingIndicator />
              ) : (
                !_isEmpty(assessments) &&
                assessments.map(({ name, slug }) => {
                  const isTaken = isAssessmentTaken(takenAssessments, {
                    slug,
                  });

                  return (
                    <LinkList
                      name={name}
                      link={`/assessments/${slug}${isTaken ? '/results' : ''}`}
                      clickHandler={redirect}
                      key={name}
                    />
                  );
                })
              )}
              <Typography
                className={classes.link}
                onClick={() => redirect('/assessments')}
              >
                {_get(siteCopy, ['pageCopy', 'mobile-dialog-menu', 'view-all'])}
              </Typography>
            </List>
          )}
          <Divider />
          <ListItem
            button
            onClick={() => redirect('/blogs')}
            className={classes.listItem}
          >
            <ListItemIcon className={classes.listIcon}>
              <img src={ArticlesIcon} alt="Blogs" />
            </ListItemIcon>
            <ListItemText
              primary={_get(siteCopy, ['pageCopy', 'submenu-labels', 'blogs'])}
              className={classes.listItemText}
            />
          </ListItem>
          <Divider />
          <ListItem
            button
            onClick={() => redirect('/news')}
            className={classes.listItem}
          >
            <ListItemIcon className={classes.listIcon}>
              <img src={NewsIcon} alt="News" />
            </ListItemIcon>
            <ListItemText
              primary={_get(siteCopy, ['pageCopy', 'submenu-labels', 'news'])}
              className={classes.listItemText}
            />
          </ListItem>
          <Divider />
          {!isCoBranded() && (
            <>
              {!subdomain && (
                <>
                  <ListItem
                    button
                    onClick={() => redirect('/?showcorp=1')}
                    className={classes.listItem}
                  >
                    <ListItemIcon className={classes.listIcon}>
                      <img
                        src={CMProIcon}
                        alt="Solutions"
                        className={classes.listItemText}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary="Solutions"
                      className={classes.listItemText}
                    />
                  </ListItem>
                  <Divider />
                </>
              )}

              <ListItem
                button
                onClick={() => redirect('/company/sponsors')}
                className={classes.listItem}
              >
                <ListItemIcon className={classes.listIcon}>
                  <img
                    src={SponsorIcon}
                    alt="Sponsors"
                    className={classes.listItemText}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="Sponsors"
                  className={classes.listItemText}
                />
              </ListItem>
              <Divider />
            </>
          )}
        </List> */}
      </Dialog>
    );
  }
}

DialogMenu.propTypes = {
  allowSignIn: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  redirect: PropTypes.func,
  profile: PropTypes.object,
  auth: PropTypes.object,
  logout: PropTypes.func,
  clientDetails: PropTypes.object,
  hasClientLogo: PropTypes.bool,
  getTakenAssessments: PropTypes.func,
};

DialogMenu.contextType = NavBarContext;

const mapStateToProps = createStructuredSelector({
  takenAssessments: makeSelectTakenAssessments(),
  clientLanding: makeSelectClientLanding(),
  locales: makeSelectLocales(),
  location: makeSelectLanguage(),
});

function mapDispatchToProps(dispatch) {
  return {
    getTakenAssessments: () => dispatch(getTakenAssessments()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withStyles(styles),
  withConnect,
)(DialogMenu);
